<label class="h-9 justify-center items-center inline-flex gap-2" [ngClass]="{'font-bold text-cdra-blue-light-700': option.selected}" *transloco="let t">
   <input class="py-1.5 justify-center items-center gap-1 flex" type="button" (change)="select()" [checked]="this.option.selected" type="checkbox"/>
   {{ t(option.translationPrefix + '.' + option.value) }}
</label>
